/**
 * hashParams.js - read the query string that rides along in the URL hash
 * (e.g. #/projects?status=Won), used for deep links into a filtered table.
 */

export function parseHashFilters() {
  const hash = window.location.hash;
  const qIdx = hash.indexOf('?');
  if (qIdx < 0) return {};
  const params = new URLSearchParams(hash.slice(qIdx + 1));
  const out = {};
  for (const [k, v] of params) out[k] = v;
  return out;
}
